import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import { MarcaProvider } from "./components/providers/MarcaProvider";
import { DashboardPage } from "./pages/dashboard";
import { UsuarioListPage } from "./pages/usuario/UsuarioListPage";
import { RequirePermissao, RequireTenant } from "./components/utils/PrivateRoute";
import { SeguradoraListPage } from "./pages/seguradora/SeguradoraListPage";
import { SeguradoListPage } from "./pages/segurado/SeguradoListPage";
import { SinistroListPage } from "./pages/sinistro/SinistroListPage";
import UsuarioFormPage from "./pages/usuario/UsuarioFormPage";
import SeguradoraFormPage from "./pages/seguradora/SeguradoraFormPage";
import SeguradoFormPage from "./pages/segurado/SeguradoFormPage";
import RelatoriosPage from "./pages/relatorios/RelatoriosPage";
import RelatorioSementesAnoPage from "./pages/relatorios/RelatorioSementesAnoPage";
import RelatorioComissoesPage from "./pages/relatorios/RelatorioComissoesPage";
import EmpresaFormPage from "./pages/empresa/EmpresaFormPage";
import { SeguroListPage } from "./pages/seguro/SeguroListPage";
import SeguroFormPage from "./pages/seguro/SeguroFormPage";
import SeguroViewPage from "./pages/seguro/SeguroViewPage";
import SinistroFormPage from "./pages/sinistro/SinistroFormPage";
import SinistroNovoPage from "./pages/sinistro/SinistroNovoPage";
import { AssinaturaPage } from "./pages/assinatura/AssinaturaPage";
import { AuditoriaPage } from "./pages/auditoria/AuditoriaPage";

export const routes: any[] = [
  {
    path: "/",
    element: <RequireTenant><MarcaProvider><App /></MarcaProvider></RequireTenant>,
    handle: 'Página Inicial',
    children: [
      {
        index: true,
        path: "/:tenant",
        element: <DashboardPage />
      },
      {
        path: "/:tenant/usuario",
        element: <RequirePermissao permissao="USUARIO_READ"><UsuarioListPage /></RequirePermissao>,
        handle: 'Usuários'
      },
      {
        path: "/:tenant/usuario/:id",
        parent: "/:tenant/usuario",
        element: <RequirePermissao permissao="USUARIO_READ"><UsuarioFormPage /></RequirePermissao>,
        handle: `Editar Usuário`,
        urlBuilder: (currentRoute: any) =>{
          return `${currentRoute.match(/\/[0-9a-f]{8}\/usuario\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/)?.[0]}`
        }
      },
      {
        path: "/:tenant/seguradora",
        element: <RequirePermissao permissao="SEGURADORA_READ"><SeguradoraListPage /></RequirePermissao>,
        handle: 'Seguradoras'
      },
      {
        path: "/:tenant/seguradora/:id",
        parent: "/:tenant/seguradora",
        element: <RequirePermissao permissao="SEGURADORA_READ"><SeguradoraFormPage /></RequirePermissao>,
        handle: 'Editar Seguradora',
      },
      {
        path: "/:tenant/segurado",
        element: <RequirePermissao permissao="SEGURADO_READ"><SeguradoListPage /></RequirePermissao>,
        handle: 'Segurados'
      },
      {
        path: "/:tenant/segurado/:id",
        parent: "/:tenant/segurado",
        element: <RequirePermissao permissao="SEGURADO_READ"><SeguradoFormPage /></RequirePermissao>,
        handle: 'Editar Segurado',
      },
      {
        path: "/:tenant/sinistro",
        element: <RequirePermissao permissao="SEGURO_READ"><SinistroListPage /></RequirePermissao>,
        handle: 'Sinistros'
      },
      {
        path: "/:tenant/sinistro/novo",
        parent: "/:tenant/sinistro",
        element: <RequirePermissao permissao="SEGURO_WRITE"><SinistroNovoPage /></RequirePermissao>,
        handle: 'Novo Sinistro',
      },
      {
        path: "/:tenant/seguros",
        element: <RequirePermissao permissao="SEGURO_READ"><SeguroListPage /></RequirePermissao>,
        handle: 'Seguros'
      },
      {
        path: "/:tenant/seguros/:codigo",
        parent: "/:tenant/seguros",
        element: <RequirePermissao permissao="SEGURO_READ"><SeguroFormPage /></RequirePermissao>,
        handle: 'Editar Seguro',
      },
      {
        path: "/:tenant/seguros/:codigo/resumo",
        parent: "/:tenant/seguros",
        element: <RequirePermissao permissao="SEGURO_READ"><SeguroViewPage /></RequirePermissao>,
        handle: 'Resumo'
      },
      {
        path: "/:tenant/seguros/:idseguro/sinistro/:idsinistro",
        parent: "/:tenant/seguros/:codigo/resumo",
        element: <RequirePermissao permissao="SEGURO_READ"><SinistroFormPage /></RequirePermissao>,
        handle: 'Editar Sinistro',
      },
      {
        path: "/:tenant/relatorios",
        element: <RequirePermissao permissao="SEGURO_READ"><RelatoriosPage /></RequirePermissao>,
        handle: 'Relatórios'
      },
      {
        path: "/:tenant/relatorios/seguros-vencendo/:ano",
        parent: "/:tenant/relatorios",
        element: <RequirePermissao permissao="SEGURO_READ"><RelatorioSementesAnoPage /></RequirePermissao>,
        handle: 'Seguros Vencendo'
      },
      {
        path: "/:tenant/relatorios/comissoes",
        parent: "/:tenant/relatorios",
        element: <RequirePermissao permissao="SEGURO_READ"><RelatorioComissoesPage /></RequirePermissao>,
        handle: 'Comissões'
      },
      {
        path: "/:tenant/auditoria",
        element: <RequirePermissao permissao="AUDITORIA_READ"><AuditoriaPage /></RequirePermissao>,
        handle: 'Auditoria'
      },
      {
        path: "/:tenant/empresa",
        element: <RequirePermissao permissao="EMPRESA_READ"><EmpresaFormPage /></RequirePermissao>,
        handle: 'Corretora'
      },
      {
        path: "/:tenant/assinatura",
        element: <RequirePermissao permissao="ADMIN"><AssinaturaPage /></RequirePermissao>,
        handle: 'Assinatura'
      },
    ]
  }
]

export const router = createBrowserRouter(routes);